export enum AdvertisingStatusEnum {
  VERIFYING = "VERIFYING",
  CONFIRMED = "CONFIRMED",
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  REJECTED = "REJECTED",
  ENDED = "ENDED",
}
